import { NavItems } from "../../../hooks/useNavigation/useNavigation.type";
import { ROUTES } from '../../routes'

export const auditsNavList: NavItems = [
    {
        label: 'All Audits',
        route: ROUTES.audits,
    },
    {
        label: 'Smart Audit Rules',
        route: ROUTES.smartAudits,
    }
]